<script lang="ts">
  import ArrowUpIcon from "$lib/icons/ArrowUpIcon.svelte";
  import {createEventDispatcher, onMount} from "svelte";
  import {clickOutside} from "$lib/directives/clickOutside";
  import {normalizedCountries} from "svelte-tel-input";
  import type {Country} from "svelte-tel-input/types";
  import type {IUser} from "$lib/interfaces/IUserMe";

  const dispatch = createEventDispatcher();
  let items: Country[] = normalizedCountries;
  let isOpen = $state(false);
  let selectedCountryId: string;
  let selected = $state<Country | undefined>(undefined);
  let dropdownRef: HTMLDivElement;
  interface Props {
    user: IUser;
    id?: string;
    name?: string;
    value?: string;
    selectedCountry?: string;
  }

  let {
    user,
    id = '',
    name = '',
    value = $bindable(''),
    selectedCountry = ''
  }: Props = $props();

  $effect(() => {
    // Use the provided selectedCountry if available, otherwise fall back to user.countryCode
    selectedCountryId = selectedCountry || user.countryCode;
    selected = items.find((item) => item.iso2 === selectedCountryId) || items[0];
  });

  function toggleDropdown() {
    isOpen = !isOpen;
  }

  function dispatchSelected(item: any) {
    selected = item;
    value = item.iso2;
    selectedCountryId = item.iso2;
    dispatch('selected', item);
    toggleDropdown();
  }

  function handleClickOutside(event: MouseEvent) {
    if (dropdownRef && !dropdownRef.contains(event.currentTarget as Node)) {
      isOpen = false;
    }
  }

  onMount(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });
</script>

<div class="relative" use:clickOutside={() => isOpen = false}>
  <button onclick={() => toggleDropdown()} class="flex justify-between items-center bg-primary-dark pl-3.5 pr-2 py-2 rounded-full w-full text-sm text-white">
    <div class="flex items-center gap-2">
      {#if selected}
        <img src="https://flagcdn.com/{selected.iso2.toLocaleLowerCase()}.svg" class="w-7 rounded" alt={selected.name}>
        {selected.name}
      {:else}
        <div>Loading...</div>
      {/if}
    </div>
    <ArrowUpIcon/>
    <input type="hidden" bind:value {name} {id}>
  </button>
  {#if isOpen}
    <div class="absolute p-2 rounded-xl z-50 bg-primary-dark w-full animate-fadeIn max-h-96 overflow-y-auto no-scrollbar">
      {#if (items)}
        {#each items as item}
          <button class="flex items-center py-2 px-3 hover:bg-primary-blue animate-fadeIn rounded-md w-full text-white" onclick={() => dispatchSelected(item)}>
            <img src="https://flagcdn.com/{item.iso2.toLocaleLowerCase()}.svg" class="w-6 mr-2 rounded" alt={item.name}>
            <span class="text-sm text-nowrap">{item.name}</span>
          </button>
        {/each}
      {:else}
        <div class="text-center text-white">Loading...</div>
      {/if}
    </div>
  {/if}
</div>
